import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchHomeProductsApi } from 'api/home_product'
import { HomeProduct, HomeProductSearchForm } from 'entities/home_product'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { homeProductColumnInfoList, HomeProductTableData } from './home_product_table'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditHomeProductForm, NewHomeProductForm } from './home_product_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const HomeProductsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<HomeProductSearchForm>()
    const searchForm = useForm<HomeProductSearchForm>(query)
    const api = useFetchHomeProductsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<HomeProduct>()
    const homeProductDisplaySetting = useDisplaySetting(homeProductColumnInfoList(searchForm), 'HomeProduct')
    const displaySettings: DisplaySetting[] = [homeProductDisplaySetting]
    const [selectedHomeProduct, setSelectedHomeProduct] = useState<HomeProduct>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof HomeProductSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`home_products?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <EditHomeProductForm
                homeProduct={selectedHomeProduct}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="商品"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewHomeProductForm
                            onComplete={() => {
                                api.execute()
                            }}
                            institutionId={query.institutionId}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['institutionId']} />
                    </>
                }
                right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={homeProductDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={homeProductDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((homeProduct: HomeProduct) => {
                                return (
                                    <CheckboxTableRow key={`homeProduct-${homeProduct.id}`} item={homeProduct} multipleCheckForm={multipleCheckForm}>
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedHomeProduct(homeProduct)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <HomeProductTableData homeProduct={homeProduct} displaySetting={homeProductDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="HomeProduct"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(HomeProductsPage)
